import { render, staticRenderFns } from "./JudgeListBeforeLayout.vue?vue&type=template&id=bda86220&scoped=true"
import script from "./JudgeListBeforeLayout.vue?vue&type=script&lang=js"
export * from "./JudgeListBeforeLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bda86220",
  null
  
)

export default component.exports